<template>
    <cadastro-simples-form
        endpoint="motivo-aula-compensada"
        rota-base="/admin/motivo-aula-compensada"
        titulo-singular="Motivo de A.C"
        :campos-extras='[
            { campo: "descricao", label: "Descrição", tipo: "text" }
        ]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
